import { logout } from '@/features/auth';
import type { State } from '@/reducers/types';
import { createSlice } from '@reduxjs/toolkit';

interface SdwState {
  sdwData: {
    answer: string;
  } | null;
  isRegenerated?: boolean;
  title?: string;
}

const initialState: SdwState = {
  sdwData: null,
  isRegenerated: undefined,
  title: undefined,
};

const { name, reducer, actions } = createSlice({
  name: 'sdw',
  initialState,
  reducers: {
    setSdwData(state, action) {
      state.sdwData = action.payload;
    },
    setIsRegenerated(state, action) {
      state.isRegenerated = action.payload;
    },
    setTitle(state, action) {
      state.title = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(logout.fulfilled, () => initialState);
  },
});

const { setSdwData, setIsRegenerated, setTitle } = actions;

export { name, reducer, setIsRegenerated, setSdwData, setTitle };

export const selectSdwData = (state: State) => state[name].sdwData;
export const selectSdwIsRegenerated = (state: State) => state[name].isRegenerated;
export const selectSdwTitle = (state: State) => state[name].title;
